// viewBlockPlugin.js
export default function viewBlockPlugin(md) {
  function parseHeader(line) {
    // :::view p=25 bgColor=yellow.50
    const rest = line.slice(":::view".length).trim();
    const attrs = {};
    const re = /(\w+)=(".*?"|'.*?'|[^\s]+)/g;
    let m;

    while ((m = re.exec(rest))) {
      const key = m[1];
      let val = m[2];

      if ((val.startsWith('"') && val.endsWith('"')) || (val.startsWith("'") && val.endsWith("'"))) {
        val = val.slice(1, -1);
      }

      if (val === "true") val = true;
      else if (val === "false") val = false;
      else if (!Number.isNaN(Number(val)) && val.trim() !== "") val = Number(val);

      attrs[key] = val;
    }

    return attrs;
  }

  function viewBlock(state, startLine, endLine, silent) {
    const start = state.bMarks[startLine] + state.tShift[startLine];
    const max = state.eMarks[startLine];
    const firstLine = state.src.slice(start, max);

    if (!firstLine.startsWith(":::view")) return false;
    if (silent) return true;

    // find closing :::
    let nextLine = startLine + 1;
    let found = false;
    while (nextLine < endLine) {
      const s = state.bMarks[nextLine] + state.tShift[nextLine];
      const e = state.eMarks[nextLine];
      const l = state.src.slice(s, e).trim();
      if (l === ":::") {
        found = true;
        break;
      }
      nextLine++;
    }
    if (!found) return false;

    const header = parseHeader(firstLine);

    // Extract inner markdown as raw text (do NOT tokenize here)
    const innerStart = startLine + 1;
    const innerEnd = nextLine;
    const inner = state.getLines(innerStart, innerEnd, 0, true);

    const tok = state.push("view", "", 0);
    tok.block = true;
    
    tok.attrs = Object?.keys(header)?.map((key) => [key, header[key]]) || [];
    tok.attrs.push(["content", inner]);
    
    state.line = nextLine + 1;
    return true;
  }

  md.block.ruler.before("fence", "view_block", viewBlock, {
    alt: ["paragraph", "reference", "blockquote", "list"],
  });
}
